"use client";

import Image from "next/image";
import { Typography } from "@mui/material";
import { getOS } from "@/utils/platformUtil";
import { useEffect, useState } from "react";

interface FlagIconProps {
  code: string;
  size?: number;
}

function countryCodeToEmoji(countryCode: string): string {
  return countryCode.toUpperCase().replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt(0)));
}

const FlagIcon = ({ code, size = 32 }: FlagIconProps) => {
  const [os, setOs] = useState<string | null>(null);
  const normalizedCode = code.trim().toLowerCase();
  const [emoji, setEmoji] = useState(countryCodeToEmoji(code));
  useEffect(() => {
    setOs(getOS());
  }, []);

  if (os === null) {
    // 서버와 동일한 첫 렌더링을 위해 emoji만 보여줌
    return (
      <Typography component="span" fontSize={size}>
        {emoji}
      </Typography>
    );
  }

  if (os === "Windows") {
    return (
      <Image
        src={`https://flagcdn.com/w80/${normalizedCode}.png`}
        alt={`${normalizedCode} flag`}
        width={size}
        height={(size * 3) / 4} // 예: 32 x 24
        style={{
          borderRadius: 2,
          objectFit: "cover",
          display: "inline-block",
        }}
      />
    );
  }

  return (
    <Typography component="span" fontSize={size}>
      {emoji}
    </Typography>
  );
};

export default FlagIcon;
